import React, { Component } from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import PromotionsApp from '../../components/promotions';
import { fetchAllPublishedPromotionsIfNeeded, fetchClosedPromotionsIfNeeded } from '../../components/promotions/actions/PromotionsActions';

const headerTags =
{
    title: 'Promoções - Cinema, shows, viagens e muito mais', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta:
    {
        description: "Participe das promoções da rádio Antena 1 e ganhe ingressos de cinema, shows, teatros, viagens nacionais e internacionais, kit's de CD's, DVD's e muito mais.",
        keywords: 'ingresso de cinema, ingresso de teatro, cd, dvd, camiseta, caneca, cafeteira, viagens, passeios, hotéis, pousadas, spa, concurso cultural, shows, eventos',
        'og:title': 'Promoções - Cinema, shows, viagens e muito mais',
        'og:description': "Participe das promoções da rádio Antena 1 e ganhe ingressos de cinema, shows, teatros, viagens nacionais e internacionais, kit's de CD's, DVD's e muito mais.",
        'og:image': 'https://a1media.antena1.com.br/image/share/promocoes.png',
    },
};

class Promocoes extends Component {
    // Make request to necessary data (in the ssr)
    static fetchData(store) {
        const allPromisses = [
            store.dispatch(fetchAllPublishedPromotionsIfNeeded()),
            store.dispatch(fetchClosedPromotionsIfNeeded()),
        ];

        return Promise.all(allPromisses);
    }


    render() {
        return (
            <div className="pageWrapper tw-container tw-m-auto tw-px-5">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <PromotionsApp />
            </div>
        );
    }
}

export default Promocoes;
